import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

export interface PlatformFeeSettings {
  percentage: number;
  flatAmountCzk: number;
}

/** Read-only current rate — used for the in-app disclosure shown to managers. */
export const getPlatformFee = async (token: string): Promise<PlatformFeeSettings> => {
  const res = await axios.get(`${API_BASE}/settings/platform-fee`, {
    headers: { Authorization: `Bearer ${token}` },
    withCredentials: true,
  });
  return res.data;
};

export const adminGetPlatformFee = async (token: string): Promise<PlatformFeeSettings> => {
  const res = await axios.get(`${API_BASE}/admin/platform-fee`, {
    headers: { Authorization: `Bearer ${token}` },
    withCredentials: true,
  });
  return res.data;
};

export const adminUpdatePlatformFee = async (
  payload: PlatformFeeSettings,
  token: string
): Promise<PlatformFeeSettings> => {
  const res = await axios.put(`${API_BASE}/admin/platform-fee`, payload, {
    headers: { Authorization: `Bearer ${token}` },
    withCredentials: true,
  });
  return res.data;
};
